<div class="page-layout simple inner-scroll"
  fxFlex>

  @if (displayHeader) {
    <div class="header p-24"
      fxLayout="column"
      fxLayout="space-between start">
      <h2>{{ groupsService.getHeaderTitle() | translate }}</h2>
      <app-getting-started [alias]="groupsService.gettingStarted">
      </app-getting-started>
    </div>
  }

  <content class="inner-scroll mat-white-bg"
    fxFlex
    fxLayout="column">
    <router-outlet></router-outlet>
  </content>

</div>
